import { atom, useAtomValue, useSetAtom } from "jotai";
import type { LocationDropdownItem } from "libs/codegen/property-onboarding";

interface StatesCitiesAtom {
    cities: LocationDropdownItem[];
    states: LocationDropdownItem[];
}

export const statesCitiesAtom = atom<StatesCitiesAtom>({
    cities: [],
    states: [],
});

export const useSetStatesCitiesAtom = () => useSetAtom(statesCitiesAtom);
export const useStatesCitiesAtomValue = () => useAtomValue(statesCitiesAtom);
